import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { useStore } from '../../../app/stores/store';
import DashboardChart from './DashboardChart';

function ChartData() {
  const { dashboardStore, commonStore } = useStore();
  const [showChart, setShowChart] = useState<boolean>(true);

  const assetTrackingLabels = [
    'New Asset Added',
    'Current Month Asset CAN Movement',
    'Pending Returns From Borrowers',
    'Assets Cleaned',
    'Assets Scheduled For Cleaning',
  ];

  const orderLabels = [
    'Waiting For Approval',
    'Approved',
    'In Progress',
    'Ready',
    'Delivered',
    'Returned',
    'Received',
  ];

  const productionLabels = dashboardStore.dashboard.prodChartData[0].Label;
  const DataLabel =
    dashboardStore.dashboard.L1CardValue === 'Inventory' &&
    dashboardStore.dashboard.L2CardValueInventory === 'Reports'
      ? assetTrackingLabels
      : dashboardStore.dashboard.L1CardValue === 'Orders'
        ? orderLabels
        : dashboardStore.dashboard.L1CardValue === 'Production'
          ? productionLabels
          : assetTrackingLabels;

  // for timeline
  const InventoryTrackingMonthData = [
    dashboardStore.dashboard.inventoryChartData.chart2AC,
    dashboardStore.dashboard.inventoryChartData.chart2AS,
    dashboardStore.dashboard.inventoryChartData.chart2CM,
    dashboardStore.dashboard.inventoryChartData.chart2NA,
    dashboardStore.dashboard.inventoryChartData.chart2PB,
  ];

  const InventoryTrackingLineChart = InventoryTrackingMonthData.map(
    (y: number[], index: number) => {
      const colors = [
        '#83ce83',
        '#FF9A76',
        '#64C9CF',
        'rgb(255, 99, 132)',
        'rgb(255, 205, 86)',
        '#95D1CC',
        '#D47AE8',
      ];
      const newArr = {
        label: DataLabel[index],
        data: y,
        fill: true,
        backgroundColor: colors[index],
        borderColor: colors[index],
        lineTension: 1,
      };
      return newArr;
    },
  );

  const productionMonthData = dashboardStore.dashboard.prodChartData[2]?.Chart2;
  //  data
  const ProductionLabels1 = dashboardStore.dashboard?.prodChartLabel;

  const productionLineChart = productionMonthData?.map(
    (y: number[], index: number) => {
      const colors = [
        '#83ce83',
        '#FF9A76',
        '#64C9CF',
        'rgb(255, 99, 132)',
        'rgb(255, 205, 86)',
        '#95D1CC',
        '#D47AE8',
        '#83ce83',
        '#FF9A76',
        '#64C9CF',
        'rgb(255, 99, 132)',
        'rgb(255, 205, 86)',
        '#95D1CC',
        '#D47AE8',
        '#83ce83',
        '#FF9A76',
        '#64C9CF',
        'rgb(255, 99, 132)',
        'rgb(255, 205, 86)',
        '#95D1CC',
        '#D47AE8',
      ];
      const newArr = {
        label: ProductionLabels1[index] || '',
        data: y || '',
        fill: true || '',
        backgroundColor: colors[index] || '',
        borderColor: colors[index] || '',
        lineTension: 1 || '',
      };
      return newArr;
    },
  );

  const ordersMonthData = [
    dashboardStore.dashboard.orderChartData.chart2WA,
    dashboardStore.dashboard.orderChartData.chart2AP,
    dashboardStore.dashboard.orderChartData.chart2IN,
    dashboardStore.dashboard.orderChartData.chart2RD,
    dashboardStore.dashboard.orderChartData.chart2DL,
    dashboardStore.dashboard.orderChartData.chart2RT,
    dashboardStore.dashboard.orderChartData.chart2RC,
  ];

  //  data
  const ordersLineChart = ordersMonthData.map((y: number[], index: number) => {
    const colors = [
      '#83ce83',
      '#FF9A76',
      '#64C9CF',
      'rgb(255, 99, 132)',
      'rgb(255, 205, 86)',
      '#95D1CC',
      '#D47AE8',
    ];
    const newArr = {
      label: DataLabel[index],
      data: y,
      fill: true,
      backgroundColor: colors[index],
      borderColor: colors[index],
      lineTension: 1,
    };
    return newArr;
  });

  const compData =
    dashboardStore.dashboard.L1CardValue === 'Inventory' &&
    dashboardStore.dashboard.L2CardValueInventory === 'Reports'
      ? dashboardStore.dashboard.prodChartData[4].Chart3Complete
      : dashboardStore.dashboard.L1CardValue === 'Orders'
        ? dashboardStore.dashboard.orderChartData.chart3Completed
        : dashboardStore.dashboard.L1CardValue === 'Production'
          ? dashboardStore.dashboard.prodChartData[4].Chart3Complete
          : dashboardStore.dashboard.prodChartData[4].Chart3Complete;

  // const InProgress =
  //   dashboardStore.dashboard.L1CardValue === 'Inventory' &&
  //   dashboardStore.dashboard.L2CardValueInventory === 'Reports'
  //     ? dashboardStore?.dashboard?.ProdchartInprogress
  //     : dashboardStore.dashboard.L1CardValue === 'Orders'
  //     ? dashboardStore.dashboard.orderChartData.chart3InProgress
  //     : dashboardStore.dashboard.L1CardValue === 'Production'
  //     ? dashboardStore?.dashboard?.ProdchartInprogress
  //     : dashboardStore?.dashboard?.ProdchartInprogress

  const MainData =
    dashboardStore.dashboard.L1CardValue === 'Inventory' &&
    dashboardStore.dashboard.L2CardValueInventory === 'Reports'
      ? dashboardStore.dashboard.inventoryChartData.chart1
      : dashboardStore.dashboard.L1CardValue === 'Orders'
        ? dashboardStore.dashboard.orderChartData.chart1
        : dashboardStore.dashboard.L1CardValue === 'Production'
          ? dashboardStore.dashboard.prodChartData[1].Chart1
          : dashboardStore.dashboard.inventoryChartData.chart1;

  const LineChartData =
    dashboardStore.dashboard.L1CardValue === 'Inventory' &&
    dashboardStore.dashboard.L2CardValueInventory === 'Reports'
      ? InventoryTrackingLineChart
      : dashboardStore.dashboard.L1CardValue === 'Orders'
        ? ordersLineChart
        : dashboardStore.dashboard.L1CardValue === 'Production'
          ? productionLineChart
          : InventoryTrackingLineChart;

  useEffect(() => {
    if (
      dashboardStore.dashboard.L1CardValue === 'Production' &&
      dashboardStore.dashboard.prodCount === 0
    ) {
      setShowChart(false);
    } else if (
      dashboardStore.dashboard.L1CardValue === 'Orders' &&
      dashboardStore.dashboard.totalOrderCount === 0
    ) {
      setShowChart(false);
    } else if (
      dashboardStore.dashboard.L1CardValue === 'Inventory' &&
      dashboardStore.dashboard.inventoryCount === 0
    ) {
      setShowChart(false);
    } else if (
      dashboardStore.dashboard.L1CardValue === '' &&
      dashboardStore.dashboard.inventoryCount === 0
    ) {
      setShowChart(false);
    } else {
      setShowChart(true);
    }
    //eslint-disable-next-line
  }, [
    dashboardStore.dashboard.L1CardValue,
    dashboardStore.dashboard.prodCount,
    dashboardStore.dashboard.totalOrderCount,
    dashboardStore.dashboard.inventoryCount,
  ]);

  if (!commonStore.RestorationCustomer && !dashboardStore.dashboard.inventoryChartData.chart3Completed)
    return (
      <div style={{ marginTop: '15rem' }}>
        <LoadingComponent />
      </div>
    );

  return (
    <>
      {showChart ? (
        <div>
          <DashboardChart
            completedData={compData}
            DataLabel={DataLabel}
            MainData={MainData}
            LineChartData={LineChartData}
            // InProgress={InProgress}
          />
        </div>
      ) : (
        // <div
        //   style={{
        //     display: 'flex',
        //     justifyContent: 'center',
        //     alignItems: 'center',
        //     width: '100%',
        //     padding: '20px',
        //   }}
        // >
        //   <p>Sorry, no data to show</p>
        // </div>
        <></>
      )}
    </>
  );
}

export default observer(ChartData);
